import type { RouteObject } from 'react-router';

// ----------------------------------------------------------------------

/** 公开路由（趣享租暂无，保留导出供 routes 组合） */
export const publicRoutes: RouteObject[] = [];
